
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground, PropsTable } from "docz";
import KardexTable from "../shared/components/KardexTable.js";
import "../shared/css/index.css";

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h1" components={components} props={{"id":"kardextable"}}>{`KardexTable`}</MDXTag>
<MDXTag name="p" components={components}>{`KardexTable es un contenedor genérico para cuando quiera desplegarse información del Kardex. Acepta una prop `}<MDXTag name="inlineCode" components={components} parentName="p">{`kardex`}</MDXTag>{` de la siguiente estructura.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`kardex = [kardexObject]
kardexObject = {
  nombre: String,
  clave: Number,
  tipo: String(OBL|OPT|OPT*),
  estado: String(A|C|BV|R|BG|BE),
  creditos: Number,
  ciclo: String
}
`}</MDXTag></MDXTag>
<Playground __position={0} __code={'() => {\n  const kardex = [\n    {\n      nombre: \'Inteligencia Artificial\',\n      clave: 1111,\n      estado: \'A\',\n      creditos: 8,\n      tipo: \'OPT\',\n      ciclo: \'2191\',\n    },\n    {\n      nombre: \'Análisis y Diseño de Sistemas de Información\',\n      clave: 1112,\n      estado: \'R\',\n      creditos: 8,\n      tipo: \'OBL\',\n      ciclo: \'2172\',\n    },\n    {\n      nombre: \'Tópicos Especiales de Bases de Datos\',\n      clave: 1113,\n      estado: \'BV\',\n      creditos: 8,\n      tipo: \'OPT\',\n      ciclo: \'2192\',\n    },\n  ]\n  return <KardexTable kardex={kardex} />\n}'} __scope={{props: this ? this.props : props,KardexTable}}>
  { () => {
    const kardex = [
      {
        nombre: "Inteligencia Artificial",
		    clave: 1111,
        estado: 'A',
        creditos: 8,
        tipo: 'OPT',
        ciclo: '2191'
      },
      {
        nombre: "Análisis y Diseño de Sistemas de Información",
		    clave: 1112,
        estado: 'R',
        creditos: 8,
        tipo: 'OBL',
        ciclo: '2172'
      },
      {
        nombre: "Tópicos Especiales de Bases de Datos",
		    clave: 1113,
        estado: 'BV',
        creditos: 8,
        tipo: 'OPT',
        ciclo: '2192'
      },
    ];
return <KardexTable kardex={kardex} />
  } }
</Playground>
<PropsTable of={KardexTable} />
           </MDXTag>
  }
}
  